module.exports = __webpack_public_path__ + "img/footer-link-33.e988ce95.png";